import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  makeStyles,
  Paper,
  TextField
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { DatePicker } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { STATUS_API } from 'src/app/constant/config';
import { getListVod, setVehicleSelected } from 'src/features/playback';
import styled from 'styled-components';

const StyledDatePicker = styled(DatePicker)`
  width: 352px;
  height: 40px;
  font-size: 16px;
  border-radius: 4px;
  transition: border-color 0.3s ease;

  &:hover {
    border-color: #ee0434;
  }

  &.ant-picker-focused {
    border-color: #ee0434;
  }

  .ant-picker-input > input {
    height: 100%;
    line-height: 40px;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    padding: '20px',
    width: 365,
    boxShadow: 'unset'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1
  },
  iconButton: {
    padding: 10
  },
  divider: {
    height: 28,
    margin: 4
  },
  titleLotrinh: {
    fontSize: '18px',
    color: '#D9042F',
    fontWeight: 700,
    marginBottom: '10px'
  },
  titleTime: {
    fontSize: '18px',
    color: '#0C1132',
    fontWeight: 600
  },
  formControl: {
    width: 340,
    marginTop: '10px',
    marginBottom: '10px'
  },
  titleHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  textRed: {
    color: 'red'
  },
  customOutline: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#D6D9DB',
        borderWidth: 1
      },
      '&:hover fieldset': {
        borderColor: '#D9042F'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#D9042F'
      }
    }
  },
  option: {
    fontSize: '14px',
    borderBottom: '1px solid #e0e0e0',
    paddingTop: 6,
    paddingBottom: 6,

    '&:last-child': {
      borderBottom: 'none'
    }
  }
}));

export default function ToolBarTracking({ listVehicle }) {
  const statusGetPositions = useSelector(
    state => state.deviceSlice.statusGetPositions
  );

  const classes = useStyles();
  const now = moment();
  const formatDate = date => moment(date).format('YYYY-MM-DD');
  const formatTime = date => moment(date).format('HH:mm');
  const [startTime, setStartTime] = React.useState('00:00');
  const [endTime, setEndTime] = React.useState(formatTime(now));
  const [playbackDate, setPlaybackDate] = React.useState(moment());
  const dispatch = useDispatch();

  const defaultFilter = {
    license_plate: '',
    device_id: '',
    serial: ''
  };

  const [filterFormValue, setFilterFormValue] = useState(defaultFilter);

  const handleSearchDevice = (playbackDate, startTime, endTime) => {
    const startTimeZone = Math.floor(
      moment(`${formatDate(playbackDate)} ${startTime}`)
        .utcOffset(0)
        .unix()
    );
    const endTimeZone = Math.floor(
      moment(`${formatDate(playbackDate)} ${endTime}`)
        .utcOffset(0)
        .unix()
    );

    const channelId = `${filterFormValue?.serial}_01`;
    const data = {
      id: filterFormValue.device_id,
      first_time: startTimeZone,
      last_time: endTimeZone,
      deviceSerial: filterFormValue?.serial,
      channelId: channelId,
      channelName: 'CH01',
      vehicleId: filterFormValue.license_plate
    };

    //GetVehiclePosition(data);
    //Lấy thông tin file playback

    dispatch(setVehicleSelected(data));
    dispatch(
      getListVod({
        channelId: data.channelId,
        start_time: data.first_time,
        end_time: data.last_time
        // channelId: '861245069435427_01',
        // start_time: '1732579980',
        // end_time: '1732662780'
      })
    );
  };

  const handleChangeLicense = value => {
    const filterValue = Object.assign({}, filterFormValue, {
      device_id: value ? value.device_id : '',
      license_plate: value ? value.license_plate : '',
      serial: value ? value.device_serial : ''
    });
    setFilterFormValue(filterValue);
  };
  const handleChangePlaybackDate = value => {
    setPlaybackDate(value);
  };
  const handleChangeStartTime = event => {
    setStartTime(event.target.value);
  };

  const handleChangeEndTime = event => {
    setEndTime(event.target.value);
  };

  const disabledLoadRoadMap = () => {
    if (
      startTime === '' ||
      endTime === '' ||
      filterFormValue.license_plate === ''
    ) {
      return true;
    }
    return statusGetPositions === STATUS_API.PENDING;
  };

  const onOk = value => {};

  return (
    <Paper
      component="form"
      style={{
        padding: '0px 0px 20px 20px',
        width: 365,
        boxShadow: 'unset'
      }}
    >
      <Box>
        <FormControl
          size="small"
          className={classes.formControl}
          style={{ width: '100%' }}
        >
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column ',
              width: '100%'
            }}
          >
            <Autocomplete
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              size="small"
              classes={{ option: classes.option }}
              options={listVehicle || []}
              getOptionLabel={option =>
                option.license_plate || 'Chọn phương tiện'
              }
              value={(listVehicle || []).find(
                option => option.device_serial === filterFormValue.serial
              )}
              onChange={(event, value) => handleChangeLicense(value)}
              disableClearable
              renderInput={params => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Chọn phương tiện"
                  InputProps={{
                    ...params.InputProps,
                    style: { fontSize: '14px' }
                  }}
                  className={classes.customOutline}
                />
              )}
              style={{ flex: 1 }}
            />
          </Box>
        </FormControl>
      </Box>
      <div>
        <span
          style={{
            fontSize: '16px',
            color: '#0C1132',
            fontWeight: 600
          }}
        >
          Chọn thời gian
        </span>
        <FormControl
          variant="outlined"
          className={classes.formControl}
          style={{ width: '100%' }}
        >
          <form noValidate>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '12px'
              }}
            >
              <InputLabel
                style={{
                  fontSize: '14px',
                  position: 'relative',
                  top: -30,
                  left: -13
                }}
              >
                Từ ngày
              </InputLabel>
              <StyledDatePicker
                format={'DD-MM-YYYY'}
                value={playbackDate}
                onChange={handleChangePlaybackDate}
                onOk={onOk}
                placeholder="Chọn thời gian"
                style={{
                  width: '345px',
                  height: '42px',
                  fontSize: '16px',
                  borderRadius: '4px'
                }}
              />
            </Box>
            <Box
              style={{
                flexDirection: 'row',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingTop: '10px'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column ',
                  width: '50%',
                  borderColor: '#E5E5E8',
                  paddingRight: '0.2em'
                }}
              >
                <TextField
                  style={{ width: '100%' }}
                  id="start-time"
                  label="Thời gian bắt đầu"
                  type="time"
                  value={startTime || ''}
                  className={classes.textField}
                  onChange={handleChangeStartTime}
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    style: {
                      fontSize: '14px'
                    }
                  }}
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column ',
                  width: '50%',
                  borderColor: '#E5E5E8',
                  paddingLeft: '0.2em'
                }}
              >
                <TextField
                  style={{ width: '100%' }}
                  id="end-time"
                  label="Thời gian kết thúc"
                  type="time"
                  value={endTime || ''}
                  className={classes.textField}
                  onChange={handleChangeEndTime}
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    style: {
                      fontSize: '14px'
                    }
                  }}
                />
              </div>
            </Box>
          </form>
        </FormControl>
      </div>

      <Button
        style={{
          background: '#D9042F',
          color: '#fff',
          paddingLeft: '30px',
          paddingRight: '30px',
          textTransform: 'inherit',
          fontSize: '16px',
          width: '100%',
          marginTop: '15px'
        }}
        disabled={disabledLoadRoadMap()}
        variant="contained"
        onClick={() => {
          handleSearchDevice(playbackDate, startTime, endTime);
        }}
      >
        {statusGetPositions === STATUS_API.PENDING ? (
          <>
            <CircularProgress size={24} style={{ color: 'white' }} />
            Vui lòng đợi ...
          </>
        ) : (
          <span> Tìm kiếm theo video </span>
        )}
      </Button>
    </Paper>
  );
}
